export default class UserAccessOutputData {
    constructor(data) {
        this.carrier = data.carrier;
        this.client = data.client;
    }
}
